<template>
  <view class="union-card-container">
    <view class="union-card-container-header">
      <view class="union-card-container-header-left">
        <view class="union-logotype">
          <image
            class="union-logotype-icon"
            src="https://ut-static.udache.com/webx/sfc/5jewOiQAoTmZ7i5nVfKvo.png"
          />
          <text>中转</text>
        </view>
        <view class="union-station">
          <text>{{ orderItem.from_station_name }}</text>
          <image
            class="train-station-icon"
            src="https://ut-static.udache.com/webx/sfc/viT-malXsrWwYdW2RR_5O.png"
          />
          <text>{{ orderItem.to_station_name }}</text>
        </view>
      </view>
      <view class="union-card-container-header-right" style="color:{{orderItem.status_color}}">
        {{ orderItem.status_name }}
      </view>
    </view>
    <es-card-del
      index="{{orderIndex}}"
      item="{{ { orderItem, index: orderIndex, titleItem } }}"
      bind:click-left="goDetail"
      bind:click-right="delData"
    >
      <view slot="mainContext" class="main-context">
        <train-card wx:for="{{rafactorOrderList}}" cardIndex="{{index + 1}}" item="{{item}}" bindtap="goDetail(orderItem)" />
      </view>
      <view slot="delContext" class="del-box">
        <view>删除</view>
      </view>
    </es-card-del>
  </view>
</template>

<script>
import { createComponent } from '@didi/es-mpx-creator'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
dayjs.locale('zh-cn')

createComponent({
  props: {
    orderItem: {
      type: Object,
      value: () => {}
    },
    titleItem: {
      type: Object,
      value: () => {}
    },
    orderIndex: {
      type: Number,
      value: 0
    }
  },
  computed: {
    rafactorOrderList() {
      if (!this.orderItem?.ticket_infos || !Array.isArray(this.orderItem?.ticket_infos)) {
        return []
      }
      return this.orderItem.ticket_infos.map((ticketInfo) => {
        // 创建不包含 ticket_infos 的新对象副本
        const { ticket_infos, ...rest } = ticketInfo
        const newItem = { ...rest, ...ticketInfo }
        if (newItem.start_time && Number.isInteger(newItem.start_time)) {
          const time = newItem.start_time * 1000
          newItem.start_time = dayjs(time).format('M月D日 周dd HH:mm')
        }
        return newItem
      })
    }
  },
  methods: {
    delData(e) {
      this.triggerEvent('delData', e.detail)
    },
    goDetail(e) {
      this.triggerEvent('goDetail', e.detail)
    }
  }
})
</script>

<style scoped lang="stylus">
.union-card-container
  display flex
  flex-direction column
  border-radius 8px
  background #fdf6f1
  &-header
    display flex
    padding 10px 15px 10px 12.5px
    justify-content space-between
    align-items center
    &-left
      display flex
      .union-logotype
        padding 3px 6px
        border-radius 4px
        font-family PingFangSC-Medium
        font-size 12px
        font-weight 500
        line-height 12px
        text-align center
        color #FFFFFF
        background #FF6400
        margin-right 8px
        &-icon
          height 11px
          width 11px
          margin-right 2px
      .union-station
        font-family PingFangSC-Medium
        font-size 14px
        font-weight 500
        line-height 16px
        color #222
        display flex
        align-items center
        .train-station-icon
          height 3px
          width 10.5px
          margin 0 2px
    &-right
      font-family PingFangSC-Medium
      font-size 14px
      font-weight 500
      line-height 17px
      color #666
  .del-box
    display flex
    justify-content flex-end
    align-items center
    border-radius 9px
    font-size 14px
    font-weight 500
    font-family PingFangSC-Regular
    height 100%
    background #F93822
    padding-right 24px
</style>

<script name="json">
module.exports = {
  component: true,
  usingComponents: {
    'train-card': './newTrainOrderCard.mpx',
    'es-card-del': '@didi/es-mpx-ui/lib/card-del/index'
  }
}
</script>